import React from 'react'
import { connect } from 'react-redux'
import { values } from 'lodash'

// Components
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'

// Redux
import { getHackers, getTeamDetails, patchTeamDetails } from 'app/state/modules/hacker'
import { triggerLrsIntegration, setLrsReducer } from 'app/state/modules/lrs'
import { getSSO, updateSSO } from 'app/state/modules/sso'

// Utils
import analytics from 'app/views/utils/analytics'

// Local Components
import AvailableLicenses from './components/AvailableLicenses'
import ContentSettings from './components/ContentSettings'
import DeveloperApi from './components/DeveloperApi'
import InviteAdmins from './components/InviteAdmins'
import InviteUsers from './components/InviteUsers'
import LRSSettings from './components/LRSSettings'
import SSOSettings from './components/SSOSettings'


class OrganizationsSettings extends React.Component {
  constructor() {
    super()

    this.handleToggleMustPassCodingExercise = this.handleToggleMustPassCodingExercise.bind(this)
    this.handleOnEnableSSO = this.handleOnEnableSSO.bind(this)
    this.handleOnUpdateMetadata = this.handleOnUpdateMetadata.bind(this)
    this.handleToggleShowAllTraining = this.handleToggleShowAllTraining.bind(this)
  }

  componentDidMount() {
    this.props.getTeamDetails(this.props.match.params.organization_uuid)
    this.props.getHackers(this.props.match.params.organization_uuid)
    this.props.getSSO(this.props.match.params.organization_uuid)

    analytics.page('organizations-settings')
  }

  handleToggleMustPassCodingExercise(mustPassCodingExercise) {
    const organizationId = this.props.match.params.organization_uuid
    this.props.patchTeamDetails(organizationId, { mustPassCodingExercise })
  }

  handleToggleShowAllTraining(showAllTraining) {
    const organizationId = this.props.match.params.organization_uuid
    this.props.patchTeamDetails(organizationId, { showAllTraining })
  }

  handleOnEnableSSO(enabled) {
    const organizationId = this.props.match.params.organization_uuid
    this.props.updateSSO(organizationId, enabled, null, null)
  }

  handleOnUpdateMetadata(metadataFile, metadataUrl) {
    const organizationId = this.props.match.params.organization_uuid

    let file = metadataFile
    let url = metadataUrl
    if (metadataFile === '') {
      file = null
    }
    if (metadataUrl === '') {
      url = null
    }
    this.props.updateSSO(organizationId, null, file, url)
  }

  render() {
    const organizationId = this.props.match.params.organization_uuid
    return (
      <OrganizationLayout data-test-id="admin-settings-component" {...this.props} active="settings">
        <h2>Settings</h2>

        <h3>Users</h3>
        <InviteUsers
          token={this.props.team.token}
          totalHackers={this.props.totalHackers}
        />
        <div className="uk-margin-top">
          <AvailableLicenses licenseCount={this.props.team.available_licenses} />
        </div>
        <hr className="uk-margin-large-top" />

        <h3>Admins</h3>
        <InviteAdmins
          organizationId={organizationId}
          totalAdmins={this.props.totalAdmins || 0}
        />
        <hr className="uk-margin-large-top" />

        <h3>Content</h3>
        <ContentSettings
          handleToggleShowAllTraining={this.handleToggleShowAllTraining}
          showAllTraining={this.props.team.show_all_training}
          handleToggleMustPassCodingExercise={this.handleToggleMustPassCodingExercise}
          mustPassCodingExercise={this.props.team.must_pass_coding_exercise}
        />
        <hr className="uk-margin-large-top" />

        <SSOSettings
          domains={this.props.domains}
          enabled={this.props.enabled}
          metadata_file={this.props.metadata_file}
          metadata_url={this.props.metadata_url}
          onEnable={this.handleOnEnableSSO}
          onUpdateMetadata={this.handleOnUpdateMetadata}
          updatingSSO={this.props.updatingSSO}
          updatingSSOError={this.props.updatingSSOError}
        />
        <hr className="uk-margin-large-top" />

        <LRSSettings
          setLrsReducer={this.props.setLrsReducer}
          lrsData={this.props.lrs}
          triggerLrsIntegration={this.props.triggerLrsIntegration}
          initialLrsValues={this.props.initialLrsValues}
        />
        <hr className="uk-margin-large-top" />

        <DeveloperApi />

      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  email: state.auth.user.email,
  team: state.hacker.currentTeamDetails,
  organizations: values(state.hacker.organizationsList),
  organizationsHash: state.hacker.organizationsHash,
  users: values(state.hacker.currentTeamHackers),
  totalHackers: state.hacker.totalHackers,
  totalAdmins: state.hacker.currentTeamDetails.total_admins,
  // sso
  domains: state.sso.domains,
  enabled: state.sso.enabled,
  metadata_file: state.sso.metadata_file,
  metadata_url: state.sso.metadata_url,
  updatingSSO: state.sso.updatingSSO,
  updatingSSOError: state.sso.updatingSSOError,
  // lrs
  lrs: state.lrs,
  initialLrsValues: state.hacker.currentTeamDetails.lrs,
})
const mapDispatchToProps = (dispatch) => ({
  getHackers: (organizationId) => dispatch(getHackers(organizationId)),
  getTeamDetails: (teamId) => dispatch(getTeamDetails(teamId)),
  patchTeamDetails: (teamId, mustPassCodingExercise) => (
    dispatch(patchTeamDetails(teamId, mustPassCodingExercise))
  ),

  // sso
  getSSO: (organizationId) => dispatch(getSSO(organizationId)),
  updateSSO: (organizationId, enabled, metadataFile, metadataUrl) => (
    dispatch(updateSSO(organizationId, enabled, metadataFile, metadataUrl))
  ),

  // lrs
  triggerLrsIntegration: (activated, errorCallback) => (
    dispatch(triggerLrsIntegration(activated, errorCallback))
  ),
  setLrsReducer: (payload) => dispatch(setLrsReducer(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationsSettings)
